export type TPipelineCountItem = {
  activityName: HiringActivity | string;
  count: number;
  averageTime: number;
};

export type TCandidatePipelineResponse = {
  totalCount: number;
  successMessage: string;
  errorMessage: string | null;
  statusCode: number;
  pipelineCountData: TPipelineCountItem[];
};

export enum HiringActivity {
  Added = 'Added',
  InvitedToApply = 'Invited to Apply',
  Applied = 'Applied',
  InScreen = 'In Screen',
  InInterview = 'In Interview',
  ToBeEvaluated = 'To be Evaluated',
  Evaluated = 'Evaluated',
  Screen = 'Screen',
  Interview = 'Interview',
  Sourced = 'Sourced',
  Offer = 'Offer',
  Hired = 'Hired',
  Submit = 'Submit',
}

export enum HMStatusListForInterview {
  Interview1Scheduled = 'Interview 1 Scheduled',
  Interview1 = 'Interview 1',
  Interview2Scheduled = 'Interview 2 Scheduled',
  Interview2 = 'Interview 2',
  Interview3Scheduled = 'Interview 3 Scheduled',
  Interview3 = 'Interview 3',
  InviteToInterview = 'Invite to Interview',
  NoAvailability = 'No Availability',
  Pending = 'Pending',
  RequestCanceled = 'Request Canceled',
  RequestExpired = 'Request Expired',
  Scheduled = 'Scheduled',
  Canceled = 'Canceled',
  Complete = 'Complete',
  Decision = 'Decision',
  Advance = 'Advance',
  Reject = 'Reject candidate (with feedback)',
  RejectProcess2 = 'Reject',
}

export enum HMStatusListForScreen {
  Screen = 'Screen',
  ConversationInProgress = 'Conversation In-Progress',
  CaptureComplete = 'Capture Complete',
  CaptureIncomplete = 'Capture Incomplete',
  ConversationComplete = 'Conversation Complete',
  ConversationIncomplete = 'Conversation Incomplete',
  ConversationExpired = 'Conversation Expired',
  ConversationCanceled = 'Conversation Canceled',
  AdvanceAuto = 'Advance-Auto',
  QueuedForReview = 'Queued for review',
  AdvanceManual = 'Advance-Manual',
  SendAssessment = 'Send Assessment',
  AssessmentInitiated = 'Assessment Initiated',
  AssessmentInProgress = 'Assessment In Progress',
  AssessmentCompleted = 'Assessment Completed',
  AssessmentAbandoned24hours = 'Assessment Abandoned (24 hours)',
  AssessmentAbandoned48hours = 'Assessment Abandoned (48 hours)',
  ASSESSMENT_CREATED = 'ASSESSMENT_CREATED',
  AssessmentComplete3TO5 = 'Assessment Complete 3-5',
  InReviewPostAssessment = 'In Review Post Assessment',
  AssessmentReviewAccepted = 'Assessment Review Accepted',
  AssessmentReviewRejected = 'Assessment Review Rejected',
  Send = 'Send',
  InProgress = 'In-Progress',
  Complete = 'Complete',
  Expired = 'Expired',
  Canceled = 'Canceled',
  CandidateFormAbandoned24hours = 'Candidate Form Abandoned (24 hours)',
  CandidateFormAbandoned48hours = 'Candidate Form Abandoned (48 hours)',
  Reject = 'Reject',
}

export type THMAcitivityStatus =
  | HMStatusListForInterview
  | HMStatusListForScreen;
export interface IInterviewersPanel {
  interviewPanelId: number;
  jobRequisitionId: number;
  organizationId: number;
  jobTitle: string;
  interviewer: IInterviewers[];
}

export interface IInterviewersPanelResponse {
  interviewPanel: IInterviewersPanel;
  successMessage: string;
  errorMessage: string;
  statusCode: number;
}

export interface IInterviewers {
  interviewerId?: number;
  interviewerName?: string;
  interviewerEmail: string;
  interviewPanelId?: number;
  saved?: boolean;
}

export interface IInterviewerPayload {
  interviewerId?: number;
  interviewerName?: string | null;
  interviewerEmail: string;
}
export interface IInterviewerPanelPayload {
  requisitionId?: string;
  organizationId?: number;
  interviewers: IInterviewerPayload[];
}
